import React from 'react';

interface IProps {
  className?: string;
  title: React.ReactElement | string;
  content?: React.ReactElement | string;
}

export const HeaderCopy: React.FC<IProps> = ({ className, title, content }) => (
  <div className={`flex-col text-eggplant ${className}`}>
    <h2 className='leading-trim-both text-edge-cap mb-4 text-2xl font-bold leading-[120%] sm:text-3xl md:text-3xl'>
      {title}
    </h2>
    {content && <span className='md:text-md text-sm font-normal leading-relaxed sm:text-base'>{content}</span>}
  </div>
);
